import { render, staticRenderFns } from "./BuildingManagement.vue?vue&type=template&id=38a5ad94&"
import script from "./BuildingManagement.vue?vue&type=script&lang=js&"
export * from "./BuildingManagement.vue?vue&type=script&lang=js&"
import style0 from "./BuildingManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports